module.exports = __webpack_public_path__ + "static/media/icon-plus-circle.5a1ac5ce.svg";